(() => {
  const uuidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

  document.querySelectorAll('form.b2b-lead-form').forEach((form) => {
    const fieldset = form.querySelector('fieldset');
    const submitButton = form.querySelector('button[type="submit"]');
    const status = form.querySelector('.form-status');
    const honeypot = form.querySelector('[name="b2b_website_url"]');
    const dateInput = form.querySelector('#firmen-event-date');
    const dateOutput = form.querySelector('#firmen-date-output');
    let idempotencyKey = crypto.randomUUID();
    let submitting = false;

    fieldset.disabled = false;

    const renderDate = () => {
      if (!dateInput.value) {
        dateOutput.hidden = true;
        dateOutput.textContent = '';
        return;
      }
      const parts = dateInput.value.split('-').map(Number);
      const eventUtc = Date.UTC(parts[0], parts[1] - 1, parts[2]);
      const approvalUtc = eventUtc - 84 * 24 * 60 * 60 * 1000;
      const today = new Date();
      const todayUtc = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
      const locale = form.elements.locale.value || document.documentElement.lang;
      const formatted = new Intl.DateTimeFormat(locale, { dateStyle: 'long', timeZone: 'UTC' }).format(new Date(approvalUtc));
      const template = approvalUtc < todayUtc ? dateOutput.dataset.toosoon : dateOutput.dataset.normal;
      dateOutput.textContent = template.replace('{date}', formatted);
      dateOutput.className = approvalUtc < todayUtc ? 'b2b-date-output b2b-date-output--warn' : 'b2b-date-output b2b-date-output--safe';
      dateOutput.hidden = false;
    };

    dateInput.addEventListener('input', renderDate);

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (submitting) return;

      if (honeypot.value) {
        status.textContent = form.dataset.error;
        status.className = 'form-status form-status--error';
        status.hidden = false;
        return;
      }
      if (!form.reportValidity()) return;

      const formData = new FormData(form);
      const lines = [
        `${form.dataset.messageOffer}: ${formData.get('offerType')}`,
        formData.get('eventDate') ? `${form.dataset.messageEvent}: ${formData.get('eventDate')}` : '',
        `${form.dataset.messageLocale}: ${formData.get('locale')}`,
        `${form.dataset.messageCampaign}: ${formData.get('campaign')}`,
        formData.get('projectNotes') ? `${form.dataset.messageNotes}:\n${formData.get('projectNotes')}` : ''
      ].filter(Boolean);
      const message = lines.join('\n\n').slice(0, 2000);
      const payload = {
        companyName: formData.get('companyName'),
        contactName: formData.get('contactName'),
        email: formData.get('email'),
        phone: formData.get('phone') || '',
        quantity: String(formData.get('quantity')),
        message,
        consentToContact: false,
        consentPurpose: formData.get('consentPurpose'),
        consentVersion: formData.get('consentVersion')
      };

      submitting = true;
      submitButton.disabled = true;
      status.textContent = form.dataset.sending;
      status.className = 'form-status';
      status.hidden = false;

      try {
        const response = await fetch(form.action, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Idempotency-Key': idempotencyKey
          },
          body: JSON.stringify(payload)
        });
        let result = null;
        try {
          result = await response.json();
        } catch (_) {
          result = null;
        }
        if (response.status !== 201 || !result || !uuidPattern.test(result.id)) throw new Error('invalid_response');

        status.textContent = form.dataset.success;
        status.className = 'form-status form-status--success';
        status.hidden = false;
        form.reset();
        dateOutput.hidden = true;
        fieldset.disabled = true;
        idempotencyKey = crypto.randomUUID();
      } catch (_) {
        status.textContent = form.dataset.error;
        status.className = 'form-status form-status--error';
        status.hidden = false;
        submitButton.disabled = false;
      } finally {
        submitting = false;
      }
    });
  });
})();